<script setup lang="ts">
import { ButtonProps } from "~/components/Utils/Button.props"
import { GridCardsBlockProps } from "./GridCardsBlock.props"

const props = withDefaults(defineProps<GridCardsBlockProps>(), {
  hasMultipleRows: false
})

const handleNavigation = (cta: ButtonProps) => {
  navigateTo(cta.path ?? "/")
}
</script>

<template>
  <div class="grid-cards-block-wrapper space-y-6">
    <p v-if="title" class="elephant-bold md:mammoth-bold uppercase">
      {{ title }}
    </p>

    <div
      class="flex flex-col gap-6 md:flex-row"
      :class="{ 'md:flex-wrap': hasMultipleRows }"
    >
      <template v-if="cards">
        <template v-for="card in cards">
          <template v-if="card.bannerType === 'Payback'">
            <ProductBlocksBrandsUtilsPaybackCard
              :class="hasMultipleRows ? 'md:w-[calc(50%-12px)]' : 'md:w-1/2'"
              v-bind="card"
            />
          </template>
          <template v-else>
            <template v-if="card.cta?.path">
              <ProductBlocksBrandsUtilsNews
                :class="[
                  'cursor-pointer',
                  hasMultipleRows ? 'md:w-[calc(50%-12px)]' : 'md:w-1/2'
                ]"
                v-bind="card"
                @click="handleNavigation(card.cta)"
              />
            </template>
            <template v-else>
              <ProductBlocksBrandsUtilsNews
                :class="hasMultipleRows ? 'md:w-[calc(50%-12px)]' : 'md:w-1/2'"
                v-bind="card"
              />
            </template>
          </template>
        </template>
      </template>
    </div>
  </div>
</template>
